module.exports = {
    'taxes': 'taxes',
};
